import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';



export default function UpdateCardBasicInfoComponent ({cardTypes,handleInnerFormChange, layouts,webPageCards }: any) {

  return (
    <>
      <AccordionContainer
    child={
        <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Layout Name"
            labelField="LayoutName"
            list={layouts}
            onValueChange={(event: any) => {
              handleInnerFormChange(event.target.value, 'PlatformWebSiteLayoutId');
            }}
            optionName="Choose Layout"
            type="select"
            value={webPageCards?.PlatformWebSiteLayoutId}
            valueField="Id"
          />
                  <InputContainer
            label="Card Name"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'CardName',
              )
            }}
            rows={4}
            type="text"
            value={webPageCards?.CardName}
          />
             <InputContainer
            label="Card Version"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'CardVersionId',
              )
            }}
            rows={4}
            type="text"
            value={webPageCards?.CardVersionId}
          />
          <InputContainer
            label="Remarks"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Remarks',
              )
            }}
            rows={4}
            type="text"
            value={webPageCards?.Remarks}
          />
        </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}